module.exports = __webpack_public_path__ + "media/images/icon/icon_g3-e03a0d579a0bc3165fa5a95842c4049c.png";